import React, { forwardRef } from "react"

type ImageProps = {
  src: string
  alt: string
  className?: string
  lazy?: boolean | string
  onClick?: any
  onMouseOver?:any
  href?: string
  width?: number | string
  height?: number | string
  role?: string
  srcSet?: string
}

const Image = forwardRef((props: ImageProps, ref: any) => {
  const { lazy, ...otherProps } = props

  return (
    <>
      <img className={props.className} ref={ref} loading={lazy ? "lazy" : undefined} {...otherProps} />
    </>
  )
})

export default Image
